import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Loading from './Loading';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';

function HeadersTest({ nexListn, _nex }) {
  const [data, setData] = useState([])
  const [url, setUrl] = useState('')
  const [page, setPage] = useState('')

  const [isLoading, setIsLoading] = useState(false)

  const [noInput1, setNoInput1] = useState(false)

  const user = useSelector(state=> state.user.user)
  const nx = useSelector(state=> state.nex.nex)

  const dispatch = useDispatch()


  useEffect(()=> {
    if(page !== '') {
        setPage('')
        setData([])
    }
}, [url])


  const getData = async () => {
    if(url !== '') {
      setNoInput1(false)

      const updateAnalytics = async () => {
        const tool = window.location.pathname.split('/').pop();
        let tools = deepClone(user.analytics.toolsUsage);
    
        if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
            tools[tool] = 1;
        } else {
            tools[tool] = Number(tools[tool]) + 1;
        }
    
        await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
    };

      setIsLoading(true)
      fetch(`${base}/res`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          type: 'ht',
          url: url,
          userId: user.id
        })
      }).then(res=> res.json()).then(data=> {
        setData(data)
        setIsLoading(false)
        dispatch(redNex(nx))
        updateAnalytics()
      })
    } else {
      if(url.trim() === '') setNoInput1(true)
    }
  }

  const getPageTest = async () => {
    if(url !== '' && page !=='') {
      setIsLoading(true)
      fetch(`${base}/res`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          type: 'ht',
          url: `${url}/${page}`,
          userId: user.id
        })
      }).then(res=> res.json()).then(data=> {
        setData(data)
        setIsLoading(false)
      })
    }
  }



  return (
    <HeadersTestContainer>
        <HeadersTestInputContainer>
            <h2>Headers Test<span style={{fontSize: 'medium'}}></span></h2>
            <HeadersTestInputInnerContainer page={page}>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': '', color: '#1eb277'}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {/* {data.length !== 0 && data[0].url !== 'N/A' && <div style={{position: 'relative', marginBottom: '20px'}}><span style={{marginLeft: '50px', color: 'gray'}}>{`${url}/`}</span><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '245px', top: '20%', fontSize: 'small'}}>Test Another Page</label><input type='text' className='page-input' style={{marginLeft: '20px'}} value={page} onChange={e=> setPage(e.target.value)}/></div>} */}
                {page === '' && 
                <>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Run Test': 'Running Test ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
                </>
                }
                {page !== '' && <button onClick={getPageTest}>Test this page!</button>}
            </HeadersTestInputInnerContainer>
        </HeadersTestInputContainer>

        {data.length !== 0 && !isLoading && <HeadersTestResContainer>
            <TestRes>
                <div><p>Name</p></div>
                <div>
                    <p>Value</p>
                </div>
                <div style={{marginLeft: 'auto', width: '100px'}}>
                    <p>Status</p>
                </div>
            </TestRes>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {data.length !== 0 && data.map(res=> {
              return (
             <TestRes>
                <div><p>{res.name}</p></div>
                <div>
                    <p>{res.value}</p>
                </div>
                <div style={{marginLeft: 'auto', width: '100px'}}>
                    <p style={{marginLeft: '20px'}}>{res.status.toLowerCase() === 'yes'? <CheckIcon style={{color: 'var(--tst-color)'}}/>: <CloseIcon style={{color: 'red'}}/>}</p>
                </div>
            </TestRes>               
              )
            })}</div>
        </HeadersTestResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Headers Test Tool examines the HTTP headers of your website to ensure they are correctly configured for SEO and performance. 
            This tool helps you identify issues such as missing headers or incorrect status codes that could affect how search engines and users interact with your site.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter your website URL in the search bar</p>
          <p>2. Click "Run Test" to analyze the HTTP headers of your site</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Check for important headers like Content-Type, Cache-Control, and Redirects to ensure optimal performance and SEO compliance</p>

        </Intro>}
    </HeadersTestContainer>
  )
}

export default HeadersTest


const HeadersTestContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const HeadersTestInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--tst-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--tst-color);
    color: white;
  }

  > div > button:hover {
    color: var(--tst-color);
    background-color: rgb(239, 239, 239);
  }
`


const HeadersTestInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }


  .page-input {
    outline: none;
    border-radius: 2px;
    width: 300px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 10px;
    font-size: medium;
  }

  > div > .input-btn {
    position: absolute;
    transform: translateY(10%);
    left: auto;
    top: 20%;
    width: 150px;
    border: none;
    padding: 5px 10px;
    cursor: ${props=> props.page === ''? 'not-allowed': 'pointer'};
    background-color: ${props => props.page === '' ? 'rgb(230, 230, 230)' : 'var(--tst-color)'};
    color: ${props=> props.page === ''? 'gray': 'white'};
  }

  > div > .input-btn:hover {
    color: ${props=> props.page === ''? 'gray': 'var(--tst-color)'};
    background-color: ${props => props.page === '' ? 'rgb(230, 230, 230)' : 'rgb(239, 239, 239)'};
  }
`


const HeadersTestResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const TestRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;


    > div {
        display: flex;
        flex-direction: column;
        margin-left: 30px;
        margin-right: 20px;
        width: 300px;
    }

    > div > p {
        display: flex;
        align-items: center;
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`